import { render, staticRenderFns } from "./EmailEventsDetailInfo.vue?vue&type=template&id=88ae902e&"
import script from "./EmailEventsDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./EmailEventsDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports